import ExamItem, {
  examItemAction,
} from '../../../../../core/components/molecules/Exam/Item';
import { Typography } from '../../../../../core/components/molecules/Typography';
import { useLiveExamsList } from '../../../hooks/AprovaLive/useLiveExamsList';
import { LiveSimulationItemDto } from '../../../models/LiveSimulationsDto.model';

interface LiveSimulationListProps {
  simulationsList: LiveSimulationItemDto[];
  handleSimulationAction: (
    action: examItemAction,
    simulation: LiveSimulationItemDto
  ) => void;
}

function LiveSimulationList({
  simulationsList,
  handleSimulationAction,
}: LiveSimulationListProps) {
  const { getStatus } = useLiveExamsList();

  return (
    <ul className='flex flex-col gap-lg'>
      {simulationsList.length === 0 && (
        <li className='flex justify-center p-4' key={`empty-list`}>
          <Typography
            variant='italic'
            size='small'
            className='text-center text-mono-color-darkest'
          >
            Nenhum simulado encontrado
          </Typography>
        </li>
      )}
      {simulationsList.map((simulation) => {
        return (
          <ExamItem
            status={getStatus(simulation)}
            title={simulation.title}
            totalQuestions={simulation.totalQuestions}
            key={simulation.id}
            correctAnswersPercentual={simulation.score}
            onButtonClick={(action) => {
              handleSimulationAction(action, simulation);
            }}
          />
        );
      })}
    </ul>
  );
}

export { LiveSimulationList };
